import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeTrainingService } from './../../../../pages/employee/services/employeetraining.service';

@Component({
  selector: 'app-register-training-past-classes-attachment-modal',
  templateUrl: './register-training-past-classes-attachment-modal.component.html',
  styleUrls: ['./register-training-past-classes-attachment-modal.component.css'],
})
export class RegisterTrainingPastClassesAttachmentModalComponent implements OnInit {
  @Input() classInfo: any;
  savedFiles: any[];

  constructor(
    public activeModal: NgbActiveModal,
    private employeeTrainingService: EmployeeTrainingService
  ) {}

  ngOnInit(): void {
    this.savedFiles = [];
    this.getAttachmentList();
  }

  openModal() {
    document.getElementById('modalShare').style.display = 'block';
    document.getElementById('fadeShare').style.display = 'block';
  }

  closeModal() {
    document.getElementById('modalShare').style.display = 'none';
    document.getElementById('fadeShare').style.display = 'none';
  }

  getAttachmentList() {
    this.openModal();
    this.employeeTrainingService.getAttachment(89, this.classInfo.TrainingClassID).then((response: any) => {
      this.savedFiles = response;
      this.closeModal();
    });
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }
}
